/* eslint-disable max-len */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
/* eslint-disable quote-props */
export default {
  data: {
    brief_title: 'Adaptive COVID-19 Treatment Trial',
    conditions: ['Corona Virus Infection'],
    is_processed: false,
    detailed_description: {
      textblock:
        'This study is an adaptive, randomized, double-blind, placebo-controlled trial to evaluate the\n      safety and efficacy of novel therapeutic agents in hospitalized adult patients diagnosed with\n      COVID-19. The study is a multicenter trial that will be conducted in up to 50 sites globally.\n      The study will be a series of 2-arm comparisons between different investigational therapeutic\n      agents and a placebo. There will be interim monitoring to introduce new arms and allow early\n      stopping for futility, efficacy, or safety. If one therapy proves to be efficacious, this\n      treatment will then become the control arm for comparison(s) with new experimental\n      treatment(s). Because of the possibility that background standards of supportive care may\n      evolve/improve over time as more is learned about successful management of COVID-19,\n      comparisons of safety and efficacy will be based on data from concurrently randomized\n      participants. An independent data and safety monitoring board (DSMB) will actively monitor\n      interim data to make recommendations about early study closure or changes to study arms.\n      Randomization will be stratified by: 1) site and 2) severity of illness at enrollment, severe\n      disease (requiring mechanical ventilation or oxygen, a SpO2 </= 94% or tachypnea (respiratory\n      rate >/= 24 breaths/min)) or mild-moderate disease (SpO2 > 94% and respiratory rate < 24\n      breaths/min without supplemental oxygen)). Subjects will be assessed daily while\n      hospitalized. Discharged patients will be asked to attend study visits at Days 15, and 29.\n      All subjects will undergo a series of efficacy, safety, and laboratory assessments. The\n      primary objective of the study is to evaluate the clinical efficacy of different\n      investigational therapeutics relative to the control arm in patients hospitalized with\n      COVID-19. The secondary objectives of the study are to 1) evaluate the clinical efficacy of\n      different investigational therapeutics as compared to the control arm as assessed by clinical\n      severity, hospitalization, and mortality, and 2) evaluate the safety of the intervention\n      through 28 days of follow-up as compared to the control arm.',
    },
    eligibility: {
      criteria: {
        inclusion: [
          'Subject (or legally authorized representative) provides written informed consent prior to initiation of any study procedures.',
          'Understands and agrees to comply with planned study procedures.',
          'Agrees to the collection of oropharyngeal (OP) swabs and venous blood per protocol.',
          'Male or non-pregnant female adult >/=18 years of age at time of enrollment.',
          'Has laboratory-confirmed novel coronavirus (SARS-CoV-2) infection as determined by polymerase chain reaction (PCR), or other commercial or public health assay in any specimen < 72 hours prior to randomization.',
          'Illness of any duration, and at least one of the following:\n     -  Radiographic infiltrates by imaging (chest x-ray, CT scan, etc.), OR\n     -  Clinical assessment (evidence of rales/crackles on exam) AND SpO2 </= 94% on room air, OR\n     -  Requiring mechanical ventilation and/or supplemental oxygen.',
          'Women of childbearing potential must agree to use at least one primary form of contraception for the duration of the study (acceptable methods will be determined by the site).',
        ],
        exclusion: [
          'Alanine transaminase/aspartate transaminase (ALT/AST) > 5 times the upper limit of normal.',
          'Stage 4 severe chronic kidney disease or requiring dialysis (i.e. estimated glomerular filtration rate (eGFR) < 30)',
          'Pregnancy or breast feeding.',
          'Anticipated transfer to another hospital which is not a study site within 72 hours.',
          'Allergy to any study medication.',
        ],
        textblock:
          'Inclusion Criteria:\n\n          1. Subject (or legally authorized representative) provides written informed consent prior\n             to initiation of any study procedures.\n\n          2. Understands and agrees to comply with planned study procedures.\n\n          3. Agrees to the collection of oropharyngeal (OP) swabs and venous blood per protocol.\n\n          4. Male or non-pregnant female adult >/=18 years of age at time of enrollment.\n\n          5. Has laboratory-confirmed novel coronavirus (SARS-CoV-2) infection as determined by\n             polymerase chain reaction (PCR), or other commercial or public health assay in any\n             specimen < 72 hours prior to randomization.\n\n          6. Illness of any duration, and at least one of the following:\n\n               -  Radiographic infiltrates by imaging (chest x-ray, CT scan, etc.), OR\n\n               -  Clinical assessment (evidence of rales/crackles on exam) AND SpO2 </= 94% on room\n                  air, OR\n\n               -  Requiring mechanical ventilation and/or supplemental oxygen.\n\n          7. Women of childbearing potential must agree to use at least one primary form of\n             contraception for the duration of the study (acceptable methods will be determined by\n             the site).\n\n        Exclusion Criteria:\n\n          1. Alanine transaminase/aspartate transaminase (ALT/AST) > 5 times the upper limit of\n             normal.\n\n          2. Stage 4 severe chronic kidney disease or requiring dialysis (i.e. estimated glomerular\n             filtration rate (eGFR) < 30)\n\n          3. Pregnancy or breast feeding.\n\n          4. Anticipated transfer to another hospital which is not a study site within 72 hours.\n\n          5. Allergy to any study medication.',
      },
      gender: 'All',
      healthy_volunteers: 'No',
      maximum_age: '99 Years',
      minimum_age: '18 Years',
    },
    id: 'NCT04280705',
    interventions: [
      {
        arm_group_label: 'Placebo',
        description:
          'The supplied matching placebo lyophilized formulation is identical in physical appearance to the active lyophilized formulation and contains the same inactive ingredients.',
        intervention_name: 'Placebo',
        intervention_type: 'Other',
      },
      {
        arm_group_label: 'Remdesivir',
        description:
          'Drug Remdesivir is a single diastereomer monophosphoramidate prodrug designed for the intracellular delivery of a modified adenine nucleoside analog GS-441524. In addition to the active ingredient, the lyophilized formulation of Remdesivir contains the following inactive ingredients: water for injection, sulfobutylether beta-cyclodextrin sodium (SBECD), and hydrochloric acid and/or sodium hydroxide.',
        intervention_name: 'Remdesivir',
        intervention_type: 'Drug',
      },
    ],
    locations: [
      {
        facility: {
          address: {
            city: 'Bethesda',
            country: 'United States',
            state: 'Maryland',
            zip: '20892-1504',
          },
          name: 'National Institutes of Health - Clinical Center, National Institute of Allergy and Infectious Diseases Laboratory Of Immunoregulation, Clinical Research Section',
        },
        links: [
          {
            description: 'More information on COVID-19',
            url: 'https://www.nih.gov/health-information/coronavirus',
          },
        ],
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Omaha',
            country: 'United States',
            state: 'Nebraska',
            zip: '68198-5400',
          },
          name: 'University of Nebraska Medical Center - Infectious Diseases',
        },
        links: [
          {
            description: 'More information on COVID-19',
            url: 'https://www.unmc.edu/coronavirus/',
          },
        ],
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Galveston',
            country: 'United States',
            state: 'Texas',
            zip: '77555-0435',
          },
          name: 'University of Texas Medical Branch - Division of Infectious Disease',
        },
        links: [
          {
            description: 'More information on COVID-19',
            url: 'https://www.utmb.edu/virusimages/VI/coronaviruses',
          },
        ],
        status: 'Not yet recruiting',
      },
      {
        facility: {
          address: {
            city: 'Spokane',
            country: 'United States',
            state: 'Washington',
            zip: '99204',
          },
          name: 'Providence Sacred Heart Medical Center',
        },
        links: [
          {
            description: 'More information on COVID-19',
            url: 'https://www.providence.org/patients-and-visitors/coronavirus-advisory',
          },
        ],
        status: 'Recruiting',
      },
      {
        facility: {
          address: {
            city: 'Seoul',
            country: 'Korea, Republic of',
            state: 'Jongno-gu',
            zip: '03080',
          },
          name: 'Seoul National University Hospital',
        },
        links: [
          {
            description: 'More information on COVID-19',
            url: 'http://www.snuh.org/global/en/main.do',
          },
        ],
        status: 'Not yet recruiting',
      },
    ],
    overall_contact: {
      email: 'jbeigel@niaid.nih.gov',
      last_name: 'John Herbert Beigel',
      phone: '13014352292',
    },
    overall_contact_backup: {},
    overall_status: 'Recruiting',
    phase: 'Phase 2',
  },
};
